<template>
    <div >
      <a-input-group compact>
      
        <a-input 
          v-if="valid"
          :style="{maxWidth: '200px', color: valid ? 'inherit' : '#AAA'}"
          placeholder="唯一值" 
          :disabled="true"
          :value="formRecord.lang_zh || formRecord.lang_en"
          @input="onInput"
        />
         <a-input 
          v-else
          :style="{maxWidth: '200px', color: valid ? 'inherit' : '#AAA'}"
          placeholder="唯一值" 
          :value="value"
          @input="onInput"
        />
        <a-button class="green-btn" @click="handleOpen"   v-if="valid"  ><CheckCircleOutlined />i18n</a-button>
        <a-button @click="handleOpen" type="primary"  v-else danger  ><CloseCircleOutlined />i18n</a-button>
       
        <!-- <a-button @click="handleOpen" type="primary"    >修改</a-button> -->
      </a-input-group>
      
      <a-modal
        :title="'国际化文案配置-' + value"
        v-model:visible="openDia" 
        @cancel="resetForm" 
        @ok="handleConfirm" 
        :confirm-loading="loading"
        width="70%"
        destroy-on-close
      >
        <div style="margin: 10px;">
          <a-alert v-if="valid"  type="success" message="支持多语言文案" banner />
          <a-alert v-else  type="error" message="未生成多语言文案" banner />
        </div>
        <a-form :model="formRecord">
           <a-form-item label="KEY">
            <span>{{ value }}</span>
          </a-form-item>
          <a-form-item label="中文" name="lang_zh">
            <a-input  v-model:value="formRecord.lang_zh" />
          </a-form-item>
          <a-form-item label="英文">
            <a-input  v-model:value="formRecord.lang_en" />
          </a-form-item>
          <!-- <a-form-item label="日文">
            <a-input  v-model:value="formRecord.lang_jp" />
          </a-form-item>
          <a-form-item label="韩文">
            <a-input  v-model:value="formRecord.lang_kr" />
          </a-form-item>
          <a-form-item label="泰文">
            <a-input  v-model:value="formRecord.lang_th" />
          </a-form-item> -->
        </a-form>
      </a-modal>
    </div>
   
  </template>
  <script>
  
  import { defineComponent, reactive, ref } from 'vue'
  import request from '@/utils/request'
  import { Modal, message } from 'ant-design-vue';
  import OSS from 'ali-oss'
  import {CheckCircleOutlined,CloseCircleOutlined} from '@ant-design/icons-vue';

  const FormRecord = {
    id: 0,
    uniq_key: '',
    lang_zh: '',
    lang_en: '',
    lang_jp: '',
    lang_kr: '',
    lang_th: '',
  }
  let inputDebounceTimer = null
  export default defineComponent({
    emits: ['ok', 'update:value', 'update:valid', 'update:zh'],
    props: ['value', 'valid'],
    components:{CheckCircleOutlined,CloseCircleOutlined},
    data(){
      return {
        loading: false,
        openDia: false,
        formRecord: {
          ...FormRecord,
        },
        // imageUrl: '',
      }
    },
    mounted() {
      this.GetByKey()
      // console.log(this.props)
      // this.imageUrl = this.modelValue
    },
    methods: {
      resetForm() {
        // this.formRecord = {
        //   ...FormRecord,
        // }
      },
      genkey(){
        return this.value
      },
      onInput(e) {
        this.$emit('update:value', e.target.value)
        this.onChange()
      },
      async GetByKey(){
        this.loading = true
        const rsp = await request.get(`/api/i18n/texts/key`, {
          key: this.genkey(),
        })
        if (rsp.data.result) {
          this.formRecord = rsp.data.result
          this.$emit('update:valid', true)
          this.$emit('update:zh', this.formRecord.lang_zh)

        } else {
          this.formRecord = {
            ...FormRecord,
          }
          this.$emit('update:valid', false)

        }
        this.loading = false
         
      },
      async handleConfirm(){
        this.loading = true
        if (this.formRecord.id) {
          const rsp = await request.put(`/api/i18n/texts/${this.formRecord.id}`, {
            ...this.formRecord,
            uniq_key: this.genkey(),
          })
        } else {
          const rsp = await request.post('/api/i18n/texts', {
            ...this.formRecord,
            uniq_key: this.genkey(),
          })
        }
        this.$emit('update:valid', true)
        this.$emit('update:zh', this.formRecord.lang_zh)
        setTimeout(() => {
          this.loading = false
          this.openDia = false
          this.resetForm()
        }, 200)
        // this.openDia = !this.openDia
      },
      onChange: function(){
        if (inputDebounceTimer) {
          clearTimeout(inputDebounceTimer)
        }
        inputDebounceTimer = setTimeout(() => {
          this.GetByKey()
        }, 200)
      },
      handleOpen: function() {
        if(this.value == ''){
          message.error('请输入唯一值')
          return
        }
        this.GetByKey()
        this.openDia = true
      }
    },
  })
  </script>
  <style  scoped>
  .green-btn:hover{
    color: #EEE;
    border:1px solid #EEE;
  }
  </style>